import { Shape } from '@teko/ds-mobile';
import { FlashSalePromotion } from 'components/FlashSalePromotion';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';

export const FlashSalePromotionBlock = () => {
  const { product, showFlashSale } = useProductDetailState();
  const { isMobile } = useTenantConfig();

  const { total, used, endAt } = product?.flashSale || {};

  const remain =
    typeof used === 'number' && typeof total === 'number'
      ? Math.min(
          total - used,
          product?.totalAvailable || Number.MAX_SAFE_INTEGER,
        )
      : 0;

  const message =
    total === used || remain <= 0
      ? t('Cháy hàng')
      : t('Còn lại {{remain}}', { remain: remain });

  if (showFlashSale && typeof used === 'number' && typeof total === 'number')
    return (
      <Shape
        paddingTop={isMobile ? 's8' : 's0'}
        padding={['s8', 's0']}
        backgroundColor="white"
      >
        <FlashSalePromotion
          progress={Math.min(100 * (used / total), 100)}
          message={message}
          endAt={endAt}
        />
      </Shape>
    );
  else return null;
};
